import {
  SiGo,
  SiTypescript,
  SiJavascript,
  SiVuedotjs,
  SiReact,
  SiNodedotjs,
  SiPython,
  SiC,
  SiCplusplus,
  SiPostgresql,
  SiMysql,
  SiRedis,
  SiDocker,
  SiGooglecloud,
  SiGnubash,
  SiLinux,
  SiGit,
  SiClaude,
  SiModelcontextprotocol,
} from "react-icons/si";
import { FaAws } from "react-icons/fa";
import { useLocale } from "../i18n/LocaleContext";

const TextLogo = ({ text }) => (
  <span className="font-black text-base md:text-lg leading-none tracking-tight">
    {text}
  </span>
);

const STACK = [
  { name: "Go",          icon: SiGo,                   color: "#00ADD8" },
  { name: "TypeScript",  icon: SiTypescript,           color: "#3178C6" },
  { name: "JavaScript",  icon: SiJavascript,           color: "#F7DF1E" },
  { name: "Python",      icon: SiPython,               color: "#3776AB" },
  { name: "C",           icon: SiC,                    color: "#A8B9CC" },
  { name: "C++",         icon: SiCplusplus,            color: "#00599C" },
  { name: "Vue.js",      icon: SiVuedotjs,             color: "#4FC08D" },
  { name: "React",       icon: SiReact,                color: "#61DAFB" },
  { name: "Node.js",     icon: SiNodedotjs,            color: "#5FA04E" },
  { name: "Bash",        icon: SiGnubash,              color: "#4EAA25" },
  { name: "Linux",       icon: SiLinux,                color: "#FCC624" },
  { name: "Git",         icon: SiGit,                  color: "#F05032" },
  { name: "Docker",      icon: SiDocker,               color: "#2496ED" },
  { name: "PostgreSQL",  icon: SiPostgresql,           color: "#4169E1" },
  { name: "MySQL",       icon: SiMysql,                color: "#4479A1" },
  { name: "SQL Server",  icon: () => <TextLogo text="SQL" />, color: "#CC2927" },
  { name: "Redis",       icon: SiRedis,                color: "#DC382D" },
  { name: "Qdrant",      icon: () => <TextLogo text="Qd" />, color: "#DC2626" },
  { name: "AWS",         icon: FaAws,                  color: "#FF9900" },
  { name: "GCP",         icon: SiGooglecloud,          color: "#4285F4" },
  { name: "n8n",         icon: () => <TextLogo text="n8n" />, color: "#EA4B71" },
  { name: "Claude",      icon: SiClaude,               color: "#D97757" },
  { name: "MCP",         icon: SiModelcontextprotocol, color: "#52525b" },
];

function pulseColor(hex) {
  const c = (hex || "").toLowerCase();
  if (c === "#000000" || c === "#000") return "#52525b";
  return hex;
}

export function TechStack() {
  const { t } = useLocale();

  return (
    <section className="relative w-full pt-2 pb-12 md:pt-4 md:pb-16 -mt-6 md:-mt-8">
      <div className="max-w-6xl mx-auto px-6 md:px-16">
        <div className="flex flex-col items-center mb-8">
          <h2 className="text-sm font-semibold tracking-[0.2em] uppercase text-zinc-500 dark:text-zinc-400">
            {t("sections.techStack")}
          </h2>
          <span className="mt-2 block h-px w-16 bg-gradient-to-r from-transparent via-zinc-400 dark:via-zinc-600 to-transparent" />
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-5xl mx-auto">
          {STACK.map(({ name, icon: Icon, color }) => {
            const brand = pulseColor(color);
            const style = { "--tech-brand": brand };

            return (
              <div
                key={name}
                className="group flex flex-col items-center justify-center gap-2 p-3 rounded-xl bg-white/40 dark:bg-zinc-900/40 backdrop-blur-sm border border-white/60 dark:border-zinc-700/50 hover:border-zinc-300 dark:hover:border-zinc-600 hover:bg-white/80 dark:hover:bg-zinc-800/60 transition-all duration-200 hover:-translate-y-1 hover:shadow-lg hover:shadow-zinc-900/5 dark:hover:shadow-black/30 w-[92px] sm:w-[100px] lg:w-[104px]"
                title={name}
              >
                <span
                  className="tech-stack-icon flex items-center justify-center w-7 h-7 md:w-8 md:h-8 group-hover:scale-110 transition-transform duration-200"
                  style={style}
                >
                  <Icon className="w-full h-full" />
                </span>
                <span
                  className="tech-stack-label text-[10px] md:text-[11px] font-medium text-center whitespace-nowrap"
                  style={style}
                >
                  {name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
